import { getNetworkSpeed } from '@smart-tv/utils/network-speed';

import { PlayerConfig } from '../types';
import formatDeviceId from './format-device-id';

const LOG_PLAYER_EVENTS = process.env.LOG_PLAYEREVENTS === 'true';

const STARTUP_BITRATE_OVERRIDE = 0;

// after the app has been installed on TV, this is the initial bitrate used to estimate resolution. After the first stream, the player's BitrateChanged event will provide the actual network speed.
const FALLBACK_STARTUP_BITRATE = 2_481_000;

const getStartupBitrate = (): number => STARTUP_BITRATE_OVERRIDE || getNetworkSpeed() || FALLBACK_STARTUP_BITRATE;

export const getPlayerConfig = (customerEmail: string, uid: string): PlayerConfig => {
  const startupBitrate = getStartupBitrate();

  return {
    analytics: [
      {
        type: 'server',
        options: {
          cuid: customerEmail,
          deviceId: formatDeviceId(uid)
        }
      }
    ],
    playback: { autoPlay: true },
    advanced: { startupBitrate },
    ...(LOG_PLAYER_EVENTS && {
      logsConfig: true,
      logs: {
        logLevel: 4, //DEBUG：5， INFO: 4, WARNING: 3, ERROR: 2, FATAL: 1, NONE: 0
        logToConsole: true
      }
    })
  };
};

export default getPlayerConfig;
